
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"transparent","d":"M0 0h20v20H0z"}}),_c('circle',{attrs:{"cx":"10","cy":"10","r":"8","fill":"#FFF3EF"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-4.524 4.89A6 6 0 015.11 6.524l8.367 8.368zm1.415-1.414L6.523 5.11a6 6 0 018.367 8.367z","fill":"#B0BEC5"}})])
          )
        }
      }
    